import { EventContextProvider } from "@codat/analytics";
import React, { useState } from "react";

import { UserState } from "../../api/public";
import { paths } from "../App/paths";
import Button from "../Button";
import ContactSales from "../ContactSales";
import Modal from "../Modal";
import { createNavPermissionMap } from "../NavContainer/utils";

interface UpgradeButtonProps {
  userState: UserState | undefined;
  hideStartUpPlan: boolean;
  className?: string;
}

export const UpgradeButton: React.FC<UpgradeButtonProps> = ({
  userState,
  hideStartUpPlan,
  className,
}) => {
  const [showContactSalesModal, setShowContactSalesModal] = useState(false);
  const closeContactSalesModal = () => setShowContactSalesModal(false);
  const navPermissionMap = createNavPermissionMap(
    userState ? userState.userPermissions : [],
    userState?.userRole
  );
  const isStartUpAccount = userState?.clientType === "ClientStartUp";
  const canAccessPlansPage = navPermissionMap?.settings?.billing?.permission;

  const buttonType: "Upgrade" | "ContactSales" = (() => {
    if (!canAccessPlansPage) {
      return "ContactSales";
    }
    if (isStartUpAccount) {
      return "Upgrade";
    }
    if (hideStartUpPlan) {
      return "ContactSales";
    }
    return "Upgrade";
  })();

  return (
    <>
      {buttonType === "Upgrade" && (
        <Button
          data-testid="upgrade-now"
          buttonName="Upgrade Now"
          className={className}
          eventProperties={{ canAccessPlansPage }}
          label="Upgrade now"
          size="small"
          to={paths.settings.BILLING}
        />
      )}
      {buttonType === "ContactSales" && (
        <Button
          data-testid="contact-sales"
          buttonName="Contact Sales"
          className={className}
          eventProperties={{ canAccessPlansPage }}
          label="Contact sales"
          size="small"
          onClick={() => setShowContactSalesModal(true)}
        />
      )}
      <EventContextProvider name="Contact Sales Modal">
        <Modal onClose={closeContactSalesModal} size="small">
          {showContactSalesModal && (
            <ContactSales onClose={closeContactSalesModal} />
          )}
        </Modal>
      </EventContextProvider>
    </>
  );
};
